// Bevétel-előrejelzés feature — query-kulcs gyár + a szűrő-állapot típusa. A tényleges hívást a route a tipizált
// ts-rest kliensen (`api.revenueForecast.useQuery`) intézi; itt CSAK a cache-címzés él (szűrő-váltás → új kulcs →
// refetch). A `@atlas/contracts` a szerződés forrás-igazsága. READ-ONLY: nincs mutation/optimistic hook.

/** A forecast-oldal szűrői (a query-kulcs része). Üres string/`__all__` = nincs szűrés az adott dimenzióra. */
export interface RevenueForecastFilters {
  /** Célhónap `YYYY-MM` (üres → a BFF az aktuális hónapot veszi). */
  month: string;
  /**
   * Szabad-szöveges kereső (üres → nincs szűkítés).
   *
   * A TÍPUSBAN A HELYE: a kulcs-hash a TELJES objektumot sorosítja, tehát `{month, statuses…}` ≠
   * `{month, search:'', statuses…}` — két azonos paraméterű lekérdezés két külön cache-bejegyzés lenne.
   * Amíg a mező hiányzott az interfészből, a TypeScript nem fogta meg az elcsúszást (a hívó változót ad
   * át, nem objektum-literált, így az excess-property check sem fut), és az Összegzés → Bevétel fül váltás
   * egy MÁSODIK, azonos `GET /revenue-forecast`-ot indított — a lap-komment szerint ~30 busz-olvasás,
   * pont az Odin percenkénti plafonja alatt.
   */
  search: string;
  /** Státusz-szűrő (multi). Üres tömb → a BFF default [active]. */
  statuses: string[];
  /** Díjtípus-szűrő (`recurring` | `one_time`); `__all__` → mind. */
  billingType: string;
  /** Fő-/alkategória-szűrő (MULTI). Üres tömb → nincs szűrés az adott dimenzióra. */
  mainCategory: string[];
  subCategory: string[];
  serviceId: string;
  planId: string;
  clientId: string;
  accountId: string;
}

/** Query-kulcs gyár — a forecast-lekérdezés + a refs (szűrő-opciók) cache egységes címzése. */
export const revenueForecastKeys = {
  all: ['revenue-forecast'] as const,
  forecast: (filters: RevenueForecastFilters) => ['revenue-forecast', 'data', filters] as const,
  /**
   * A BEVÉTEL-LISTA kulcsa. SZÁNDÉKOSAN ugyanaz a szűrő-objektum, mint a kimutatásé, de MÁS ág: a két fül
   * ugyanazt a halmazt szűri, viszont más alakot kér a szervertől (aggregátum vs. lapozott sorok) — egy
   * közös kulcs a kettőt egymás cache-ére ültetné.
   */
  rows: (filters: RevenueForecastFilters) => ['revenue-forecast', 'rows', filters] as const,
  refs: () => ['revenue-forecast', 'refs'] as const,
};
